import { FC } from 'react'
import { useSelector } from 'react-redux'

import { MasterCampaignPlanCustomSection } from 'api/interfaces/MasterCampaignPlan'
import { MasterCampaignPlanCampaignBuilder } from 'api/interfaces/MasterCampaignStub'
import { RootState } from 'app/rootReducer'

import { getPlanDescription } from '../../utils/planContentUtils'
import CustomizableSection from './CustomizableSection'

export interface PlanDescriptionProps {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  section: MasterCampaignPlanCustomSection | null | undefined
  onEdit: () => void
  onDelete: () => void
  showActions?: boolean
}

const PlanDescription: FC<PlanDescriptionProps> = ({ campaigns, section, onEdit, onDelete, showActions = true }) => {
  const { currentAccount } = useSelector((state: RootState) => state.app)

  if (!currentAccount) {
    return null
  }

  const planDescription = getPlanDescription(currentAccount.name)

  return <CustomizableSection section={section} defaultTitle='' defaultContent={planDescription.combined} defaultShowTitle={false} separator='spacer' onEdit={onEdit} onDelete={onDelete} showActions={showActions} />
}

export default PlanDescription
